import { Box, styled } from '@mui/material';

import { COLORS } from '../../../configs/colors';

export const MobileLayoutRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${COLORS.White};
`;

export const MobileContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
`;
